import { apiUrl2 } from '../../settings'

export const getAgentListByDirectUniversityUrl = () => {
  return apiUrl2 + '/api/direct-university-agents'
}
